import React from 'react'
import { Route, Routes } from 'react-router-dom'
import MainLayout from '../layouts/MainLayout'
import CoursesPage from '../pages/admin/coursesPage'
import MyCoursesPage from '../pages/student/myCoursesPage'
import CourseSubjectsPage from '../pages/admin/coursesPage/courseSubjectsPage'
import CourseTopicsPage from '../pages/admin/coursesPage/courseTopicsPage'
import QuestionSettingsPage from '../pages/admin/coursesPage/questionSettingsPage'
import SubjectsPage from '../pages/admin/subjectsPage'
import MySubjectsPage from '../pages/student/subjectsPage'
import TopicSettingsPage from '../pages/admin/topicsPage/TopicSettingsPage'
import Home from '../pages/Home/Home'
import Login from '../pages/Login'
import NotFound from '../pages/NotFound'
import SubjectPage from '../pages/student/subjectPage'
import ExamPage from '../pages/student/examPage'
import ProtectedRoute from '../components/ProtectedRoute'
import ExamResultPage from '../pages/student/examResultPage'
import StudentListPage from '../pages/admin/studentListPage'
import TeacherListPage from '../pages/admin/teacherListPage'
import ManagerListPage from '../pages/admin/managerListPage/ManagerListPage'
import GroupListPage from '../pages/admin/groupListPage'
import StudentCoursesPage from '../pages/admin/studentCoursesPage'
import CourseProgressPage from '../pages/admin/studentProgress/courseProgressPage'
import TopicsProgressPage from '../pages/admin/studentProgress/topicsProgressPage'
import CoursesProgressPage from '../pages/admin/studentProgress/coursesProgressPage'
import TopicsPage from '../pages/admin/topicsPage'
import GroupDetailsPage from '../pages/admin/groupDetailsPage/GroupDetailsPage'
import TeacherExamResultPage from '../pages/teacher/teacherExamResultPage'
import TeacherSectionAnalysisPage from '../pages/teacher/teacherSectionAnalysisPage'
import TeacherCoursesPage from '../pages/teacher/coursesPage'
import TeacherSubjectsPage from '../pages/teacher/subjectsPage'
import TeacherSubjectPage from '../pages/teacher/subjectPage'
import CuratorStudentListPage from '../pages/curator/studentListPage/StudentListPage'
import CuratorGroupListPage from '../pages/curator/groupListPage'
import CuratorGroupStudentsPage from '../pages/curator/groupStudentsPage'
import CuratorStudentProgressPage from '../pages/curator/studentProgressPage'
import CuratorAnalysisPage from '../pages/curator/analysisPage'
import ConfirmMail from '../components/registrationForm/components/ConfirmMail'
import PricePage from '../pages/admin/pricePage/PricePage'
import BuyCoursePage from '../pages/student/buyCoursePages/buyCoursePage/BuyCoursePage'
import CheckoutPage from '../pages/student/buyCoursePages/checkoutPage/CheckoutPage'
import SalesReportListPage from '../pages/admin/salesReportListPage/SalesReportListPage'
import PromocodeListPage from '../pages/admin/promocodeListPage/PromocodeListPage'
import CoursePage from '../pages/admin/coursesPage/coursePage'
import TimetablePage from '../pages/student/timetable/TimetablePage'
import ExamsPage from '../pages/admin/examsPage/ExamsPage'
import ExamListPage from '../pages/admin/examsPage/examListPage/ExamListPage'
import AnalyticsPage from '../pages/admin/analyticsPage'
import SubjectAnalyticsPage from '../pages/admin/analyticsPage/subjectAnalyticsPage/SubjectAnalyticsPage'
import NewStudentListPage from '../pages/admin/newstudentListPage/StudentListPage'
import SellCoursePage from '../pages/admin/sellCoursePage/SellCoursePage'
import SellCheckoutPage from '../pages/admin/sellCoursePage/checkoutPage/CheckoutPage'
import PaymentStatusPage from '../pages/admin/sellCoursePage/paymentStatusPage/PaymentStatusPage'
import SchedulePage from '../pages/admin/schedulePage/SchedulePage'
import CourseSchedulePage from '../pages/admin/schedulePage/courseSchedulePage/CourseSchedulePage'
import LessonDetailsPage from '../pages/admin/schedulePage/courseSchedulePage/lessonDetailsPage/LessonDetailsPage'
import ProfilePage from '../pages/curator/profilePage/ProfilePage'
import SellersReportPage from '../pages/admin/sallersReport/SellersReportPage'

const AppRouter = () => {
    return (
        <>
            <Routes>
                <Route
                    path="/"
                    element={<Home />}
                />
                <Route
                    path="/login"
                    element={<Login showLoginPage={true} />}
                />
                <Route
                    path="/sign-up"
                    element={<Login showLoginPage={false} />}
                />
                <Route
                    path="/api/auth/mail-activate/:token"
                    element={<ConfirmMail />}
                />

                <Route element={<ProtectedRoute />}>
                    <Route element={<MainLayout />}>
                        <Route path="analytics">
                            <Route
                                index
                                element={<AnalyticsPage />}
                            />
                            <Route
                                path=':courseId'
                                element={<SubjectAnalyticsPage />}
                            />
                        </Route>
                        <Route path="courses">
                            <Route
                                index
                                element={<CoursesPage />}
                            />

                            <Route
                                path="new"
                                element={<CoursePage />}
                            />

                            <Route
                                path="edit/:id"
                                element={<CoursePage />}
                            />

                            <Route
                                path=":courseId"
                                element={<CourseSubjectsPage />}
                            />

                            <Route
                                path=":courseId/:courseSubjectId"
                                element={<CourseTopicsPage />}
                            />

                            <Route
                                path=":courseId/:courseSubjectId/:courseTopicId"
                                element={<TopicSettingsPage />}
                            />
                        </Route>

                        <Route path="price">
                            <Route
                                index
                                element={<PricePage />}
                            />
                        </Route>

                        <Route
                            path="questions/:topicTestId"
                            element={<QuestionSettingsPage />}
                        />

                        <Route path="buy-course">
                            <Route
                                index
                                element={<BuyCoursePage />}
                            />

                            <Route
                                path="checkout/:courseId/:coursePriceId"
                                element={<CheckoutPage />}
                            />
                        </Route>

                        <Route path="sell-course">
                            <Route
                                index
                                element={<SellCoursePage />}
                            />
                            <Route
                                path="checkout"
                                element={<SellCheckoutPage />}
                            />
                            <Route
                                path="payment-status"
                                element={<PaymentStatusPage />}
                            />
                        </Route>

                        <Route path="subjects">
                            <Route
                                index
                                element={<SubjectsPage />}
                            />

                            <Route
                                path="topics/:subjectId"
                                element={<TopicsPage />}
                            />
                        </Route>

                        <Route path="exams">
                            <Route
                                index
                                element={<ExamsPage />}
                            />
                            <Route
                                path=":courseId"
                                element={<ExamListPage />}
                            />
                        </Route>

                        <Route path="schedule">
                            <Route
                                index
                                element={<SchedulePage />}
                            />
                            <Route
                                path=":courseId"
                                element={<CourseSchedulePage />}
                            />
                            <Route
                                path=":courseId/:lessonId"
                                element={<LessonDetailsPage />}
                            />
                        </Route>


                        <Route path="students">
                            <Route
                                index
                                element={<StudentListPage />}
                            />

                            <Route
                                path=":studentId"
                                element={<StudentCoursesPage />}
                            />
                        </Route>

                        <Route path="new-students">
                            <Route
                                index
                                element={<NewStudentListPage />}
                            />
                        </Route>
                        <Route path="new-students">
                            <Route
                                path=":studentId"
                                element={<StudentCoursesPage />}
                            />
                        </Route>

                        <Route path="teachers">
                            <Route
                                index
                                element={<TeacherListPage />}
                            />
                        </Route>

                        <Route path="managers">
                            <Route
                                index
                                element={<ManagerListPage />}
                            />
                        </Route>

                        <Route path="sales-report">
                            <Route
                                index
                                element={<SalesReportListPage />}
                            />
                        </Route>

                        <Route path="sellers-report">
                            <Route
                                index
                                element={<SellersReportPage />}
                            />
                        </Route>

                        <Route path="promocode">
                            <Route
                                index
                                element={<PromocodeListPage />}
                            />
                        </Route>

                        <Route path="timetable">
                            <Route
                                index
                                element={<TimetablePage />}
                            />
                        </Route>

                        <Route path="groups">
                            <Route
                                index
                                element={<GroupListPage />}
                            />

                            <Route
                                path=":groupId"
                                element={<GroupDetailsPage />}
                            />
                        </Route>

                        <Route path="my-courses">
                            <Route
                                index
                                element={<MyCoursesPage />}
                            />

                            <Route
                                path=":userCourseEnrollId"
                                element={<MySubjectsPage />}
                            />

                            <Route
                                path=":courseId/:userSubjectEnrollId"
                                element={<SubjectPage />}
                            />

                            <Route
                                path="exam-result/:topicTestId"
                                element={<ExamResultPage />}
                            />
                        </Route>

                        <Route path="teacher-courses">
                            <Route
                                index
                                element={<TeacherCoursesPage />}
                            />

                            <Route
                                path="subjects"
                                element={<TeacherSubjectsPage />}
                            />

                            <Route
                                path="subjects/:courseSubjectId"
                                element={<TeacherSubjectPage />}
                            />

                            <Route
                                path="exam-result/:topicTestId"
                                element={<TeacherExamResultPage />}
                            />

                            <Route
                                path="section-analysis/:courseSubjectId/:sectionId/:typeEnum/:language"
                                element={<TeacherSectionAnalysisPage />}
                            />
                        </Route>

                        <Route path="progress">
                            <Route
                                path=":studentId"
                                element={<CoursesProgressPage />}
                            />

                            <Route
                                path=":studentId/:courseId"
                                element={<CourseProgressPage />}
                            />

                            <Route
                                path=":studentId/:courseId/:subjectId"
                                element={<TopicsProgressPage />}
                            />
                        </Route>

                        <Route path="curator">
                            <Route
                                path="profile"
                                element={<ProfilePage />}
                            />
                            <Route path="students">
                                <Route
                                    index
                                    element={<CuratorStudentListPage />}
                                />

                                <Route
                                    path=":userCourseEnrollId"
                                    element={<CuratorStudentProgressPage />}
                                />
                            </Route>


                            <Route
                                path="analysis"
                                element={<CuratorAnalysisPage />}
                            />

                            <Route path="groups">
                                <Route
                                    index
                                    element={<CuratorGroupListPage />}
                                />
                                <Route path=":groupId/students">
                                    <Route
                                        index
                                        element={<CuratorGroupStudentsPage />}
                                    />

                                    <Route
                                        path=":studentId/:userCourseEnrollId"
                                        element={<CuratorStudentProgressPage />}
                                    />
                                </Route>
                            </Route>
                        </Route>
                    </Route>

                    <Route
                        path="exam/:examId"
                        element={<ExamPage />}
                    />
                </Route>

                <Route
                    path="*"
                    element={<NotFound />}
                />
            </Routes>
        </>
    )
}

export default AppRouter
